// extracted by mini-css-extract-plugin
export default {"paymentCard__bankImage":"paymentCard_paymentCard__bankImage__qVjwM"};